import { FileActionButton } from "../file-action/file-action-controls";
import React, { useState, useEffect, Suspense, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { complaintmodel } from '../../models/complaints/complaint-model';
import { Toast } from "primereact/toast";
import { complaintExport } from '../Complaint/complaint-list-export';
import ComplaintService from '../../services/complaint/ComplaintService';
import AppLoading from '../app-loading/app-loading';
import AllComplaintDatable from './AllComplaintDataTable';
import { complaintsExport } from './complaints-list-export';
import ComplaintSearch from './ComplaintSearch';
import { complaintmodel2 } from '../../models/complaints/complaint-model';

const ComplaintMain: React.FC = () => {
  const toast = useRef<Toast>(null);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [filteredComplaints, setFilteredComplaints] = useState<complaintmodel[]>([]);
  const [complaintList, setComplaintList] = useState<complaintmodel[]>([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageSize, setPageSize] = useState(10);
  const [complaintType, setComplaintType] = useState<'product' | 'service'>('product');

  const [filters, setFilters] = useState<any>({
    complaintType: 'product'
  });

  useEffect(() => {
    const loadComplaints = async () => {
      setLoading(true);
      try {
        let response;
        if (filters.complaintType === 'product') {
          response = await ComplaintService.GetAllProductComplaints();
        } else {
          response = await ComplaintService.GetAllServiceComplaints();
        }
        
        let initialFiltered = [...response];
        if (filters.startDate && filters.endDate) {
          initialFiltered = initialFiltered.filter(complaint => {
            const complaintDate = new Date(complaint.createdDate);
            return complaintDate >= filters.startDate && 
                   complaintDate <= filters.endDate;
          });
        }
        
        if (filters.customerID) {
          const searchTerm = filters.customerID.toString().toLowerCase();
          initialFiltered = initialFiltered.filter(complaint => {
            const customerIdStr = complaint.customerId?.toString().toLowerCase() || '';
            const mobileStr = complaint.mobile?.toString().toLowerCase() || '';
            const customerNameStr = complaint.customerName?.toLowerCase() || '';
            return customerIdStr.includes(searchTerm) || 
                   mobileStr.includes(searchTerm) || 
                   customerNameStr.includes(searchTerm);
          });
        }
        
        setComplaintList(response);
        setFilteredComplaints(initialFiltered);
        setTotalRecords(initialFiltered.length);
      } catch (error) {
        console.error('Error loading complaints:', error);
        setComplaintList([]);
        setFilteredComplaints([]);
        setTotalRecords(0);
      } finally {
        setLoading(false);
      }
    };

    loadComplaints();
  }, [pageNo, pageSize, filters]);

  const handleSearch = (searchFilters: any) => {
  setPageNo(1);
  if (!searchFilters.startDate && !searchFilters.endDate && !searchFilters.customerID) {
    setComplaintType(searchFilters.complaintType || 'product');
    setFilters({ complaintType: searchFilters.complaintType || 'product' });
    setFilteredComplaints(complaintList);
    setTotalRecords(complaintList.length);
    return;
  }

  setComplaintType(searchFilters.complaintType || 'product');
  setFilters({
    ...searchFilters,
    complaintType: searchFilters.complaintType || 'product'
  });
    
    if (complaintList.length > 0) {
      let filtered = [...complaintList];

      if (searchFilters.startDate && searchFilters.endDate) {
        filtered = filtered.filter(complaint => {
          const complaintDate = new Date(complaint.createdDate);
          return complaintDate >= searchFilters.startDate && 
                 complaintDate <= searchFilters.endDate;
        });
      }

      if (searchFilters.customerID) {
        const searchTerm = searchFilters.customerID.toString().toLowerCase();
        filtered = filtered.filter(complaint => {
          const customerIdStr = complaint.customerId?.toString().toLowerCase() || '';
          const mobileStr = complaint.mobile?.toString().toLowerCase() || '';
          const customerNameStr = complaint.customerName?.toLowerCase() || '';
          
          return customerIdStr.includes(searchTerm) || 
                 mobileStr.includes(searchTerm) || 
                 customerNameStr.includes(searchTerm);
        });
      }
      
      setFilteredComplaints(filtered);
      setTotalRecords(filtered.length);
    }
  };

  const handlePageChange = async (event: any) => {
    const newPageNumber = Math.floor(event.first / event.rows) + 1;
    setPageNo(newPageNumber);
    setPageSize(event.rows);
  };

  const hadelNewDate = (updatedComplaint: complaintmodel2) => {
    setComplaintList(prev => {
      const updatedList = prev.map(complaint => 
        complaint.id === updatedComplaint.id ? {
          ...complaint,
          description: updatedComplaint.description,
          image: updatedComplaint.image,
          video: updatedComplaint.video,
          remarks: updatedComplaint.remarks,
          customerSupportAction: updatedComplaint.customerSupportAction,
          severity: updatedComplaint.severity,
          modifiedBy: updatedComplaint.modifiedBy,
          modifiedDate: updatedComplaint.modifiedDate,
          complaintId: complaint.complaintId,
          complaintNumber: complaint.complaintNumber,
          complaintDate: complaint.complaintDate,
          customerId: complaint.customerId,
          purchaseInvoiceId: complaint.purchaseInvoiceId,
          invoiceNo: complaint.invoiceNo,
          productId: complaint.productId,
          packingType: complaint.packingType,
          dateCodeBatchCode: complaint.dateCodeBatchCode,
          complaintImage: complaint.complaintImage,
          complaintCategoryId: complaint.complaintCategoryId,
          complaintTypeId: complaint.complaintTypeId,
          actionedbyId: complaint.actionedbyId,
          correctiveAction: complaint.correctiveAction,
          preventiveAction: complaint.preventiveAction,
          actionById: complaint.actionById,
          statusId: complaint.statusId,
          actionDate: complaint.actionDate,
          complainantSatisfaction: complaint.complainantSatisfaction,
          copqInRs: complaint.copqInRs,
          createdBy: complaint.createdBy,
          createdby: complaint.createdby,
          createdbyName: complaint.createdbyName,
          createdDate: complaint.createdDate,
          updatedBy: complaint.updatedBy,
          updatedbyname: complaint.updatedbyname,
          updatedDate: complaint.updatedDate,
          productCategoryId: complaint.productCategoryId,
          custName: complaint.custName,
          productName: complaint.productName,
          complaintCategory: complaint.complaintCategory,
          complaintType: complaint.complaintType,
          status: complaint.status,
          actionedbyname: complaint.actionedbyname,
          name: complaint.name,
          mobile: complaint.mobile,
          productCategory: complaint.productCategory,
          invoiceId: complaint.invoiceId,
          orderInvoiceID: complaint.orderInvoiceID,
          invoiceNoWithDate: complaint.invoiceNoWithDate,
          categoryId: complaint.categoryId,
          customerName: complaint.customerName,
          categoryName: complaint.categoryName,
          invoiceDetails: complaint.invoiceDetails,
          createdByName: complaint.createdByName,
          actionedByName: complaint.actionedByName
        } : complaint
      );
      return updatedList;
    });
    
    setFilteredComplaints(prev => {
      const updatedList = prev.map(complaint => 
        complaint.id === updatedComplaint.id ? {
          ...complaint,
          description: updatedComplaint.description,
          image: updatedComplaint.image,
          video: updatedComplaint.video,
          remarks: updatedComplaint.remarks,
          customerSupportAction: updatedComplaint.customerSupportAction,
          severity: updatedComplaint.severity,
          modifiedBy: updatedComplaint.modifiedBy,
          modifiedDate: updatedComplaint.modifiedDate,
          complaintId: complaint.complaintId,
          complaintNumber: complaint.complaintNumber,
          complaintDate: complaint.complaintDate,
          customerId: complaint.customerId,
          purchaseInvoiceId: complaint.purchaseInvoiceId,
          invoiceNo: complaint.invoiceNo,
          productId: complaint.productId,
          packingType: complaint.packingType,
          dateCodeBatchCode: complaint.dateCodeBatchCode,
          complaintImage: complaint.complaintImage,
          complaintCategoryId: complaint.complaintCategoryId,
          complaintTypeId: complaint.complaintTypeId,
          actionedbyId: complaint.actionedbyId,
          correctiveAction: complaint.correctiveAction,
          preventiveAction: complaint.preventiveAction,
          actionById: complaint.actionById,
          statusId: complaint.statusId,
          actionDate: complaint.actionDate,
          complainantSatisfaction: complaint.complainantSatisfaction,
          copqInRs: complaint.copqInRs,
          createdBy: complaint.createdBy,
          createdby: complaint.createdby,
          createdbyName: complaint.createdbyName,
          createdDate: complaint.createdDate,
          updatedBy: complaint.updatedBy,
          updatedbyname: complaint.updatedbyname,
          updatedDate: complaint.updatedDate,
          productCategoryId: complaint.productCategoryId,
          custName: complaint.custName,
          productName: complaint.productName,
          complaintCategory: complaint.complaintCategory,
          complaintType: complaint.complaintType,
          status: complaint.status,
          actionedbyname: complaint.actionedbyname,
          name: complaint.name,
          mobile: complaint.mobile,
          productCategory: complaint.productCategory,
          invoiceId: complaint.invoiceId,
          orderInvoiceID: complaint.orderInvoiceID,
          invoiceNoWithDate: complaint.invoiceNoWithDate,
          categoryId: complaint.categoryId,
          customerName: complaint.customerName,
          categoryName: complaint.categoryName,
          invoiceDetails: complaint.invoiceDetails,
          createdByName: complaint.createdByName,
          actionedByName: complaint.actionedByName
        } : complaint
      );
      return updatedList;
    });
  };

  const handelComplaintList = (params: complaintmodel[]) => {
    setComplaintList(params);
    setFilteredComplaints(params);
  };

  return (
    <>
      <Suspense fallback={<AppLoading />}>
        <Toast ref={toast} position="top-center" />
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
          <div className="col-12">
            <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
              <h5 className="ml-1 mb-0">External Actions for QA</h5>
              <span>
                <FileActionButton action="export"
                    className="text-black border-round mr-2 mb-1"
                    onClick={() => complaintsExport(
                        filteredComplaints.length > 0 ? filteredComplaints : complaintList,
                        complaintType 
                    )}
                    icon="pi pi-file-export mr-1"
                    text
                    raised
                    tooltip="Export to Excel"
                    tooltipOptions={{ position: 'top' }}
                    >
                    Export Registered Complaints
                    </FileActionButton>
              </span>
            </div>
            
            <ComplaintSearch
              onSearch={handleSearch}
              setLoading={setLoading}
              setNewData={hadelNewDate}
              initialDates={filters.dateRange}
            />
          </div>
          
          <AllComplaintDatable
            data={filteredComplaints}
            updatedData={hadelNewDate}
            complaintList={handelComplaintList}
            pageNo={pageNo}
            pageSize={pageSize}
            handlepagechange={handlePageChange}
            totalRecordsCount={totalRecords}
            complaintType={complaintType}
          />
        </div>
        {loading && <AppLoading />}
      </Suspense>
    </>
  );
};

export default ComplaintMain;